module.exports = __webpack_public_path__ + "img/canada.a4122561.png";